export default {
  title: 'Why regenerate this image?',
  description: 'Help us improve the AI by telling us what was off.',
  reasons: {
    wrong_style: 'Wrong style',
    wrong_colors: 'Wrong colors',
    wrong_food_item: 'Wrong food item',
    low_quality: 'Low quality',
    doesnt_match_brand: "Doesn't match my brand",
    text_issues: 'Text or labels are wrong',
    other: 'Other',
  },
  details_label: 'Anything else? (optional)',
  details_placeholder: 'Add more details to help us understand…',
  cancel: 'Cancel',
  confirm: 'Regenerate',
};
